import EdudoResponse from '../models/edudo-response';
import HttpService from './http-service';

class ClassroomService {
  async listClassroomStudents(): Promise<ClassroomStudents[]> {
    const response = await HttpService.getJson<
      EdudoResponse<ClassroomStudents[]>
    >(`/v1/classrooms/ClassroomsWithStudents`);

    return response.data;
  }
}

export default ClassroomService;
